<template>
  <section>
    <div v-if="loading">
      <div class="grid grid-cols-12 gap-6">
        <div class="col-span-12 xxl:col-span-9 grid grid-cols-12 gap-6">
          <!-- General Report -->
          <div class="col-span-12 mt-8">
            <div class="intro-y flex h-10 justify-between">
              <h2 class="text-lg font-medium truncate mr-5">Reporte General</h2>
              <div class="flex space-x-2">
                <email-download-list-button
                  :classname="'mr-0 button--sm'"
                  text="Descargar Lista de Cortes"
                  v-if="emailsdownload.includes(usersession.email)"
                />
                <router-link :to="'/admin/hours-tasks'">
                  <button
                    class="button button--sm xs:w-10 sm:w-52 flex items-center justify-center bg-theme-1 text-white zoom-in"
                  >
                    <Icon :name="'file'" :classname="'w-4 h-4 sm:mr-2'" />
                    <span class="hidden sm:block">Resumen de horas</span>
                  </button>
                </router-link>
                <router-link :to="'/admin/calendar/' + usersession.slug">
                  <button
                    class="button button--sm xs:w-10 sm:w-32 flex items-center justify-center bg-theme-1 text-white zoom-in"
                  >
                    <Icon :name="'calendar'" :classname="'w-4 h-4 sm:mr-2'" />
                    <span class="hidden sm:block">Calendario</span>
                  </button>
                </router-link>
                <router-link to="/admin/platforms" class="w-50">
                  <button
                    class="button button--sm xs:w-10 sm:w-32 flex items-center justify-center bg-theme-1 text-white zoom-in"
                  >
                    <Icon :name="'globe'" :classname="'w-4 h-4 sm:mr-2'" />
                    <span class="hidden sm:block">Plataformas</span>
                  </button>
                </router-link>
              </div>
            </div>
            <p
              class="typing text-md mb-2 hidden sm:block"
              v-if="usersession"
              :style="{ width: 48 + usersession.name.length + 'ch' }"
            >
              Bienvenido(a) {{ usersession.nickname }}, a continuación
              encontraras el reporte general.
            </p>
            <div class="grid grid-cols-12 gap-6">

              <div class="col-span-12 sm:col-span-6 xl:col-span-5 intro-y">
                <div class="box">
                  <h2 class="text-lg font-medium px-5 py-3 border-b">
                    Generar Contraseñas
                  </h2>
                  <div class="flex flex-col lg:flex-row items-center p-5">
                    <div
                      class="lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
                      v-if="password"
                    >
                      <div class="relative">
                        <input
                          type="text"
                          v-model="password"
                          required
                          :class="`input border flex-1 w-64`"
                        />
                        <Copy :text="password" />
                      </div>
                      <p class="flex mt-1 text-xs">
                        Clic en el icono
                        <Icon
                          name="copy"
                          classname="w-4 h-4 mx-2 text-gray-500"
                        />
                        para copiar.
                      </p>
                    </div>
                    <div class="flex mt-4 lg:mt-0">
                      <button
                        class="button text-white bg-theme-1 mr-2 zoom-in"
                        @click="generatePassword()"
                      >
                        Generar {{ password != '' ? 'Nueva' : '' }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-span-12 sm:col-span-4 xl:col-span-4 intro-y">
                <div class="box">
                  <h2 class="text-lg font-medium px-5 py-4 border-b">Tip</h2>
                  <div
                    class="flex flex-col lg:flex-row items-center py-3 px-5"
                    v-if="tip"
                  >
                    <div class="col-span-12 bg-white p-2 text-md">
                      {{ tip.description }}
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <!-- END: General Report -->
        </div>
      </div>
    </div>
    <div v-else>
      <app-loading></app-loading>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Copy from '@/components/admin/partials/Copy'
import Loading from '@/components/admin/partials/LoadingWhite'
import EmailDownloadListButton from '@/components/admin/email/EmailDownloadListButton'

export default {
  name: 'DashboardUser',
  data() {
    return {
      loading: false,
      password: '',
      tip: null,
      emailsdownload: [
        'juan.garcia@inxaitcorp.com',
        'juan.ruiz@inxaitcorp.com',
      ],
    }
  },
  async created() {
    try {
      await this.get(`library/filter?category=Tips`).then((data) => {
        const { model } = data

        if (model) {
          this.tip = model
        }
      })
    } catch (error) {
      window.$toast.error(error)
    }
  },
  computed: {
    ...mapGetters({
      usersession: 'getUser',
    }),
  },
  async beforeMount() {
    this.loading = true
  },
  methods: {
    generatePassword() {
      let all =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789*+=)(/&%$#!|[]'
      let mayus = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      let minus = 'abcdefghijklmnopqrstuvwxyz'
      let numbers = '0123456789'
      let symbols = '*+=)(/&%$#!|[]'
      this.password = ''
      let new_pass = ''
      for (let i = 0; i < 2; i++) {
        let generate_mayus = mayus[Math.floor(Math.random() * mayus.length)]
        let generate_minus = minus[Math.floor(Math.random() * minus.length)]
        let generate_numbers =
          numbers[Math.floor(Math.random() * numbers.length)]
        let generate_symbols =
          symbols[Math.floor(Math.random() * symbols.length)]
        new_pass += generate_mayus
        new_pass += generate_minus
        new_pass += generate_numbers
        new_pass += generate_symbols
      }
      for (let i = 0; i < 8; i++) {
        let generate_all = all[Math.floor(Math.random() * all.length)]
        new_pass += generate_all
      }
      this.password = new_pass
    },
    ...mapActions(['get']),
  },
  components: {
    Icon,
    appLoading: Loading,
    Copy,
    EmailDownloadListButton,
  },
}
</script>
<style>
.typing {
  animation: typing 2s steps(100), blink 0.5s step-end infinite;
  white-space: nowrap;
  overflow: hidden;
  border-right: 1px solid;
}

@keyframes typing {
  from {
    width: 0;
  }
}

@keyframes blink {
  50% {
    border-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// DashboardUser.vue?02b9047e